import { UTCDate } from '@date-fns/utc';
import { format } from 'date-fns';

import { DEFAULT_FORMAT_DATE_STR } from './formatDate';

export const formatDateUtc = (iso: string | Date) => {
  return format(new UTCDate(iso), `${DEFAULT_FORMAT_DATE_STR}`) + ' UTC';
};
